import // ADMIN_ROLE_NAME,
// CASE_ADMIN_ROLE_NAME,
// CASE_MANAGER_ROLE_NAME,
// CLAIM_REP_ROLE_NAME,
// INVOICER_ROLE_NAME,
// PEER_REVIEWER_ROLE_NAME,
// SERVICE_PROVIDER_ROLE_NAME,
// SOCIAL_WORKER_ROLE_NAME,
'./Constants'

export const CAPABILITIES = {
  CREATE_REFERRAL_SOURCES: 'referral:create',
  EDIT_REFERRAL_SOURCES: 'referral:edit',
  CREATE_CASE: 'case:create',
  READ_CASE: 'case:read',
  UPDATE_CASE: 'case:update',
  CREATE_USER: 'user:create',
  READ_USER: 'user:read',
  UPDATE_USER: 'user:update',
  APPROVE_REPORT: 'report:approve',
  RETURN_REPORT: 'report:return',
  MANAGE_JOBS: 'case:assignments:update',
  VIEW_DASHBOARD_REPORTS: 'dashboard:view_reports',
  VIEW_DASHBOARD_APPOINTMENTS: 'dashboard:view_appointments',
  DOWNLOAD_PRODUCTIVITY_REPORT: 'productivity-report:createandread',
  DELETE_TASK: 'task:delete',
  DELETE_CASE: 'case:delete',
  MANAGE_CASE_TYPES: 'casetype:manage',
  CREATE_APPOINTMENT: 'appointment:create',
  CREATE_TASK: 'task:create',
  PROMPT_ENGINEER: 'prompt:engineer',
}

// Pre-seeded standard role capabilities matching backend RoleConfiguration
let ROLE_CAPABILITIES = {
  admin: [
    'case:read',
    'case:create',
    'case:update',
    'case:delete',
    'case:assignments:update',
    'case:status:update',
    'case:status:read',
    'appointment:read',
    'appointment:create',
    'appointment:update',
    'appointment:delete',
    'task:read',
    'task:create',
    'task:update',
    'task:delete',
    'referral:read',
    'referral:create',
    'referral:update',
    'provider:read',
    'provider:create',
    'provider:update',
    'report:approve',
    'report:return',
    'prompt:engineer',
  ],
  'case-admin': [
    'case:read',
    'case:create',
    'case:update',
    'case:delete',
    'case:assignments:update',
    'case:status:update',
    'case:status:read',
    'appointment:read',
    'appointment:create',
    'appointment:update',
    'appointment:delete',
    'task:read',
    'task:create',
    'task:update',
    'task:delete',
    'referral:read',
    'referral:create',
    'referral:update',
    'provider:read',
    'provider:create',
    'provider:update',
    'report:approve',
    'report:return',
    'prompt:engineer',
  ],
  'case-manager': [
    'case:read',
    'case:create',
    'case:update',
    'case:delete',
    'case:assignments:update',
    'case:status:update',
    'case:status:read',
    'appointment:read',
    'appointment:create',
    'appointment:update',
    'appointment:delete',
    'task:read',
    'task:create',
    'task:update',
    'task:delete',
    'referral:read',
    'referral:create',
    'referral:update',
    'provider:read',
    'provider:create',
    'provider:update',
    'prompt:engineer',
  ],
  'peer-reviewer': [
    'case:read',
    'case:create',
    'case:update',
    'case:delete',
    'case:status:update',
    'case:status:read',
    'appointment:read',
    'appointment:create',
    'appointment:update',
    'task:read',
    'task:create',
    'task:update',
    'referral:read',
    'referral:create',
    'referral:update',
    'provider:read',
    'provider:create',
    'provider:update',
    'report:approve',
    'report:return',
    'dashboard:view_reports',
    'dashboard:view_appointments',
    'productivity-report:createandread',
    'prompt:engineer',
  ],
  'prompt-engineer': ['prompt:engineer'],
}

export const setRoleCapabilities = capabilities => {
  ROLE_CAPABILITIES = { ...ROLE_CAPABILITIES, ...capabilities }
}

export const Permissions = {
  can: (user, capability) => {
    if (!user || !user.roles || !Array.isArray(user.roles)) return false

    return user.roles.some(role => {
      const caps = ROLE_CAPABILITIES[role]
      return caps && caps.includes(capability)
    })
  },
}

export default Permissions
